import { render, staticRenderFns } from "./TournamentQuestions.vue?vue&type=template&id=0c836161"
import script from "./TournamentQuestions.vue?vue&type=script&lang=js"
export * from "./TournamentQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports